import { store } from "react-notifications-component";

// Class to handle notifications
class NotificationService {
  // Success notification
  static success(message, duration = 2000) {
    store.addNotification({
      title: "Success!",
      message: message,
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: duration,
        onScreen: true,
      },
    });
  }

  // Error notification
  static error(message, duration = 3000) {
    store.addNotification({
      title: "Error!",
      message: message,
      type: "danger",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: duration,
        onScreen: true,
      },
    });
  }
}

export default NotificationService;
